import { Box, Region } from '@auth0/quantum-product';
import * as React from 'react';
export var TenantDescription = function (_a) {
    var locality = _a.locality, label = _a.label;
    return (React.createElement(Box, { display: "flex", alignItems: "center" },
        React.createElement(Region, { locality: locality, size: "small", label: label })));
};
